import React from 'react';
import { Card, Form, Input } from 'antd';
import { FormInstance } from 'antd/es/form';

const { TextArea } = Input;

interface AccommodationProps {
  form: FormInstance;
}

const Accommodation: React.FC<AccommodationProps> = ({ form }) => {
  return (
    <Card title="Accommodation" style={{ marginBottom: 16 }}>
      <Form.Item
        label="What did you request?"
        name={['accommodation_info', 'accommodation_requested']}
      >
        <TextArea rows={4} placeholder="Describe what you requested" />
      </Form.Item>

      <Form.Item
        label="What was the date of this request?"
        name={['accommodation_info', 'date_of_request']}
      >
        <Input placeholder="MMDDYY" />
      </Form.Item>
    </Card>
  );
};

export default Accommodation;

